import * as DOMPurify from 'dompurify';

DOMPurify.addHook('afterSanitizeAttributes', (node: Element | HTMLLinkElement) => {
  if ('target' in node) {
    const target = node.getAttribute('target');
    if (target !== '_blank') {
      node.removeAttribute('target');
      node.removeAttribute('rel');
    } else {
      node.setAttribute('rel', 'noreferrer');
    }
  }
});

const sanitizeHTML = (markup: string | Node) =>
  DOMPurify.sanitize(markup, {
    ADD_ATTR: ['target', 'rel'],
  });

export { DOMPurify, sanitizeHTML };
